import Moves from "./components/Moves";

function App() {
  return (
    <div className="App">
      <div className="content">
        <Moves/>
      </div>
    </div>
  );
}

export default App;
